export default __webpack_public_path__ + "static/media/flipkart.fb3ec24d.png";